module.exports = __webpack_public_path__ + "img/software_img3.665c86b7.png";